module.exports = __webpack_public_path__ + "img/141.77b2adab.jpg";